import { AuditGridTemplate as template } from './audit-grid.template';
import { AuditGridStyles as styles } from './audit-grid.styles';
import { customElement, FASTElement, observable } from '@microsoft/fast-element';
import { ZeroGridPro as zeroAgGrid } from '@genesislcap/foundation-zero-grid-pro';
import { Select } from '@genesislcap/foundation-zero';
import { IAuditTrail } from '../../../../services/audit-trail.service';
import { AUDIT_RFQ_COLUMNS } from './column-config';
import { AUDIT_VPPA_COLUMNS } from './column-config';
import { AUDIT_NEGOTIATION_COLUMNS } from './column-config';

const name = 'audit-grid';

export enum TypeDropdown {
  VPPA = 'VPPA',
  RFQ = 'RFQ',
  NEGOTIATION = 'NEGOTIATION',
}

@customElement({
  name,
  template,
  styles,
})
export class AuditGrid extends FASTElement {
  @IAuditTrail auditTrainService: IAuditTrail;

  @observable auditGrid: zeroAgGrid;
  @observable auditList: Array<any> = [];
  @observable searchTextValue: string = '';
  @observable typeDropdown: Select;
  @observable typeDropdownValue: string;
  @observable typeDropdownValues = [
    { value: 'VPPA', text: 'VPPA' },
    { value: 'RFQ', text: 'RFQ' },
    { value: 'NEGOTIATION', text: 'Negotiation' },
  ];

  connectedCallback(): void {
    super.connectedCallback();

    const gridOptions = {
      animateRows: true,
      suppressRowClickSelection: true,
      scrollbarWidth: 10,
    };

    this.auditGrid.gridOptions = gridOptions;
  }

  public onGridReady() {
    this.auditGrid.gridApi.setRowData(this.auditList);
  }

  public searchAudit() {
    if (this.searchTextValue) {
      switch (this.typeDropdownValue) {
        case TypeDropdown.RFQ: {
          this.auditGrid.gridApi.setColumnDefs(AUDIT_RFQ_COLUMNS(this));
          this.getRFQAudit();
          break;
        }
        case TypeDropdown.VPPA: {
          this.auditGrid.gridApi.setColumnDefs(AUDIT_VPPA_COLUMNS(this));
          this.getVPPAAudit();
          break;
        }
        case TypeDropdown.NEGOTIATION: {
          this.auditGrid.gridApi.setColumnDefs(AUDIT_NEGOTIATION_COLUMNS(this));
          this.getNegotiationAudit();
          break;
        }
      }
    }
  }

  public getRFQAudit() {
    this.auditTrainService.getRfqAudit(this.searchTextValue).then((response) => {
      if (response) {
        this.auditGrid.gridApi.setRowData(response.REPLY);
      }
    });
  }

  public getVPPAAudit() {
    this.auditTrainService.getVppaAudit(this.searchTextValue).then((response) => {
      if (response) {
        this.auditGrid.gridApi.setRowData(response.REPLY);
      }
    });
  }

  public getNegotiationAudit() {
    this.auditTrainService.getNegotiationAudit(this.searchTextValue).then((response) => {
      if (response) {
        this.auditGrid.gridApi.setRowData(response.REPLY);
      }
    });
  }

  public downloadGrid() {
    this.auditGrid.gridApi.exportDataAsCsv();
  }
}
